import { z } from 'zod/v4';

export const FlowTypesEnum = z.enum(['flight']);
export const EntitySourcesEnum = z.enum(['planning-service']);
